
export const updateInCollection = (collection, itemKey, itemUpdateValue) => {
  const keys = Object.keys(collection)

  if (itemKey && itemUpdateValue && keys.includes(itemKey)) {
    return {
      ...collection,
      [itemKey]: {
        ...collection[itemKey],
        ...itemUpdateValue
      }
    }
  }

  return collection
}

export const addToCollection = (collection, itemKey, itemValue) => {
  return {
    ...collection,
    [itemKey]: itemValue
  }
}

export const existInCollection = (collection, itemKey) => {
  // If every key in collection not equals itemKey - then key not exist
  // We need oposit scenario
  return !!(collection && collection[itemKey])
}

export const removeFromCollection = (collection, itemKey) => {
  const {
    [itemKey]: x,
    ...newCollection
  } = collection

  return newCollection
}

export const toCollection = (array) => {
  if (!array) {
    return {}
  }

  return Object.values(array).reduce((acc, value) => {
    if (!value.id) {
      return acc
    }

    return {
      ...acc,
      [value.id]: value
    }
  }, {})
}
